<template>
  <div class="sub_content col-12 mt-2">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm">
        <div class="row">
          <InputWithValidation
            rules="required|min:2"
            type="text"
            label="소모품이름"
            title="소모품이름"
            name="form.name"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.name"
            description=""
            placeholder="소모품이름을 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:1|numeric"
            type="number"
            label="교환개월"
            title="교환개월"
            name="form.month"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.month"
            description=""
            placeholder="교환개월을 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:2|numeric"
            type="text"
            label="교환Km"
            title="소모품이름"
            name="form.km"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.km"
            description=""
            placeholder="소모품이름을 입력해주세요."
          />
        </div>
        <hr/>
        <div class="float-right">
          <b-button type="reset" size="sm" variant="danger" class="mr-2">다시쓰기</b-button>
          <b-button type="submit" size="sm" variant="primary" class="mr-2">저장</b-button>
          <b-button type="button" size="sm" variant="dark" v-on:click="cancel">취소</b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import ax from '@/api/parts'

export default {
  name: 'UserView',
  components: {
    ValidationObserver,
    InputWithValidation,
  },
  data () {
    return {
      form_: {
        name: '',
        month: '',
        km: ''
      },
      form: {}
    }
  },
  watch: {
    'form.tel': function () {
      this.form.tel = this.phoneNumberMask(this.form.tel)
    }
  },
  created () {
    this.form = _.cloneDeep(this.form_)
  },
  mounted () {
    if (this.$route.params.seq) {
      ax.get(this.$route.params.seq, response => {
        this.form = response
      })
    }
  },
  methods: {
    onSubmit () {
      ax.save(this.$route.params.seq || null, this.form, (code, msg) => {
        this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: msg
        })
        if (code === 200) {
          this.$router.push({ path: '/parts', query: this.$route.query })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    cancel () {
      this.$router.push({ path: '/parts', query: this.$route.query })
    }
  }
}
</script>

<style lang="scss" scoped>

.sub_content {
}


</style>
